import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import type { CMSCategoryRawData } from '@/Shared/AutoGenerated/Main'
import CMSSubcategory from '@/CMS/Content/Entity/CMSSubcategory'

export default class CMSCategory {
    constructor(
        public readonly title: string,
        public readonly description: string,
        public readonly slug: string,
        public readonly url: string,
        public readonly subcategories: CMSSubcategory[],
    ) {
        ensureNoUndefinedProperties(this)
    }

    getArticleCount(): number {
        return this.subcategories.reduce((articleCount, subcategory) => {
            return articleCount + subcategory.articles.length
        }, 0)
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(entityData: CMSCategoryRawData): CMSCategory {
        return new CMSCategory(
            entityData.title,
            entityData.description,
            entityData.slug,
            entityData.url,
            CMSSubcategory.hydrateMultiple(entityData.subcategories),
        )
    }

    static hydrateMultiple(entitiesData: CMSCategoryRawData[]): CMSCategory[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
